import React from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import { Link } from "ui-kit/Link";

export const NotFound: React.FC = () => (
  <Container>
    <Title>404</Title>
    <Message>
      <FormattedMessage
        id="NotFound.Title"
        defaultMessage="Page not found"
        description="Page not found"
      />
    </Message>
    <StyledLink to="/">
      <FormattedMessage
        id="NotFound.GoHomepage"
        defaultMessage="Go to homepage"
        description="Go to homepage"
      />
    </StyledLink>
  </Container>
);

const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #0e0e0e;
  color: #fff;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 96px;
  margin-bottom: 24px;
`;

const Message = styled.p`
  font-size: 20px;
  color: #aaa;
  margin-bottom: 32px;
`;

const StyledLink = styled(Link)`
  padding: 12px 24px;
  background-color: #fff;
  color: #0e0e0e;
  text-decoration: none;
  border-radius: 8px;
  font-weight: bold;
  transition: background 0.3s;

  &:hover {
    background-color: #ddd;
  }
`;
